import React, { createContext, useContext, useEffect, useState } from 'react';

type StateCode = 'ga' | 'fl' | 'ca' | 'tx' | 'ny' | 'nj' | string;

interface StateContextType {
  state: StateCode;
  setState: (s: StateCode) => void;
}

const StateContext = createContext<StateContextType | undefined>(undefined);

export const useStateSelection = () => {
  const ctx = useContext(StateContext);
  if (!ctx) throw new Error('useStateSelection must be used within StateProvider');
  return ctx;
};

export const StateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setStateInternal] = useState<StateCode>(() => localStorage.getItem('re_state') || 'ga');

  useEffect(() => {
    localStorage.setItem('re_state', state);
  }, [state]);

  const setState = (s: StateCode) => setStateInternal(s);

  return (
    <StateContext.Provider value={{ state, setState }}>
      {children}
    </StateContext.Provider>
  );
};






